/* global $ */

const ignoredTags = [
  'BUTTON',
  'A',
  'INPUT',
  'TEXTAREA',
  'LABEL',
];

const ClickableTable = {
  /**
   * @param {Node} node
   * @return {void}
   */
  create(node) {
    this.node = node;

    $(this.node).on('click', 'tr', (e) => {
      const { tagName } = e.target;

      if (
        ignoredTags.indexOf(tagName) < 0 &&
        !$(e.target).parents(ignoredTags.join(', ')).length
      ) {
        const $row = $(e.currentTarget);

        if (typeof $row.data('url') !== 'undefined') {
          window.location = $row.data('url');
        }
      }
    });
  },
};

export default ClickableTable;
